import Vue from 'vue'
import Vuex from 'vuex'
import jwt_decode from "jwt-decode";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    Admin: JSON.parse(localStorage.getItem('Admin')) || {
      Token: '',
      Id: '',
      RefId: '',
      Username: '',
      Email: '',
      OTPConfirm: 0,
      Expire: '',
      Role: '',
      Branch: '',
      BranchTeamId: '',
      Permission: [],
      IsForceChangePwd: false,      
    },
    RefreshToken: false,
    Insurances: [],
    NamePrefix: [],
    Provinces: [],
    MenuWhtc50: {},
    CitizenType: 0
  },
  mutations: {
    setRefreshToken (state, data){
      state.RefreshToken = data
    },
    setAuth (state, data){
      var decoded = jwt_decode(data);
      state.Admin.Token = data;
      state.Admin.Id = decoded.Id;
      state.Admin.RefId = decoded.RefId.toUpperCase();
      state.Admin.Username = decoded.sub;
      state.Admin.Email = decoded.email;
      state.Admin.OTPConfirm = (decoded.OTPConfirm == 'True'?1:0);
      state.Admin.Expire = decoded.exp;
      state.Admin.Role = decoded.Role;
      state.Admin.Branch = decoded.Branch;
      state.Admin.BranchTeamId = decoded.BranchTeamId;
      state.Admin.Permission = decoded.Permission;
      state.Admin.IsForceChangePwd = decoded.IsForceChangePwd == 'True'?1:0;
      localStorage.setItem('Admin', JSON.stringify(state.Admin))
    },
    clearAuth (state, data){
      state.Admin.Token = '';
      state.Admin.Id = '';
      state.Admin.RefId = '';
      state.Admin.Username = '';
      state.Admin.Email = '';
      state.Admin.OTPConfirm = 0;
      state.Admin.Expire = '';
      state.Admin.Role = '';
      state.Admin.Branch = '';
      state.Admin.BranchTeamId = '';
      state.Admin.Permission = [];
      state.Admin.IsForceChangePwd = false;
      localStorage.clear();
    },
    setInsurances (state, data){
      state.Insurances = data;
    },
    setNamePrefix (state, data){
      state.NamePrefix = data;
    },
    setProvinces (state, data){
      state.Provinces = data;
    },
    setMenuWhtc50(state, data){
      state.MenuWhtc50 = data;
    },
    setCitizenType(state, data){
      state.CitizenType = data;
    },
  },
  getters: {
    checkAuth: state => {
      return state.Admin.RefId != ""
    }
  }
})